module.exports = __webpack_public_path__ + "static/media/indiamart.ddbd3d32.png";